import styled from '@emotion/styled';

const INPUT_HEIGHT = '44px';

export const FormWrapper = styled.form`
  position: relative;
  display: inline-block;
  max-width: 510px;
  width: 100%;
  margin-bottom: 100px;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: ${INPUT_HEIGHT};
  padding: 0 36px 0 15px;
  border: 1px solid #ccc;
  border-radius: 0;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  font-size: 1.1em;

  &:focus {
    outline: 0;
    border-color: #66afe9;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(102, 175, 233, 0.6);
  }
`;

export const SearchError = styled.p`
  height: 20px;
  margin: 10px 0 0;
  color: ${({ theme }) => theme.colors.danger};
`;

export const SubmitButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  height: ${INPUT_HEIGHT};
  padding: 0 8px;
  background-color: transparent;
  border: 0;

  &:hover {
    cursor: pointer;
  }
`;
